import CheckDevice from '../../Modules/CheckDevice.js';
import * as CustomProperty from '../../Modules/CustomProperty.js';
import Animation from '../../Modules/Animation.js';
import DrawerMenu from '../../Modules/DrawerMenu.js';
import Modal from '../../Modules/Modal.js';
import * as UpdateStatus from '../../Modules/UpdateStatus.js';
import Slider from '../../Modules/Slider.js';
import * as CustomScroll from '../../Modules/CustomScroll.js';
import * as Accordion from '../../Modules/Accordion.js';
import * as Tab from '../../Modules/Tab.js';
import SmoothScroll from '../../Modules/SmoothScroll.js';
import Float, { toggleFloatOnFooter } from '../../Modules/Float.js';
import Lottie from '../../Modules/Lottie.js';
import ScrollCopy from '../../Modules/ScrollCopy.js';


const preinit = (e) => {
  UpdateStatus.load();
}

const init = () => {
  UpdateStatus.load();
  CheckDevice();
  CustomProperty.init();
  Slider();
  DrawerMenu.init();
  Modal.init();
  CustomScroll.init();
  SmoothScroll();
  Float();
  // ヘッダーが追従する帯になり常時表示になったため、フッター重なり時の退避は無効化
  // toggleFloatOnFooter();
  Lottie();
  ScrollCopy();
  Accordion.init();
  Tab.init();
}

const resize = () => {
  UpdateStatus.resize();
  CheckDevice();
  CustomProperty.resize();
  CustomScroll.resize();
}

const resizeW = () => {
  CustomProperty.resizeW();
}

const scroll = () => {
  UpdateStatus.scroll();
  CustomProperty.scroll();
  Animation();
}

const load = () => {
  UpdateStatus.load();
  Animation();
}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}